import * as React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow, Pagination, Navigation, Autoplay } from "swiper";
import "swiper/css";
import "swiper/css/bundle";
import "swiper/css/effect-coverflow";
import VrTherpay from "../../../../assets/images/vrtherpay.png";
import { Link } from "react-router-dom";
interface WhyUsMainCompProps {}

export const WhyUsMainComp: React.FunctionComponent<WhyUsMainCompProps> = (
  props
) => {
  return (
    // <!--Why Us Start-->
    <div className="why-us pt-100 pb-50 bg-dark-blue">
      <div className="common-container">
        <div className="why__us__flex_box">
          <div className="why_us_main_title">
            <div className="common-row">
              <div className="common-col-12 common-sm-12 ">
                <div className="common-heading-home ">
                  <h2>Other Solutions</h2>
                </div>
                <p className="pwhy-text mt-10">
                  Bring learning to life with immersive AR-VR technology, making
                  complex concepts easy and engaging for students. Foster
                  creativity, critical thinking, and future-ready skills.
                </p>
              </div>
            </div>
          </div>

          <div className="new__whyus_block">
            <Swiper
              slidesPerView={3}
              initialSlide={4}
              spaceBetween={30}
              // effect={"coverflow"}
              grabCursor={true}
              centeredSlides={false}
              loop={true}
              coverflowEffect={{
                rotate: 0,
                stretch: 0,
                depth: 100,
                modifier: 1,
                slideShadows: true,
              }}
              navigation={{
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              }}
              pagination={{
                clickable: true,
              }}
              // autoplay={{
              //   delay: 8000,
              //   disableOnInteraction: true,
              // }}
              breakpoints={{
                0: {
                  slidesPerView: 1,
                },
                640: {
                  slidesPerView: 2,
                },
                768: {
                  slidesPerView: 2,
                },
                1024: {
                  slidesPerView: 3,
                },
              }}
              modules={[EffectCoverflow, Pagination, Navigation, Autoplay]}
              className="mySwiper"
            >
              <SwiperSlide>
                <Link to="https://drive.google.com/file/d/1r5lPPQdve18uNhQV0Ja8RPmlZyy9dK2U/view?usp=sharing" target="blank">
                  <div className="why___flex">
                    <div className="why__img">
                      <img
                        src="https://ddappcdn.techxr.co/techxrWeb/home/arvrlabimage.png"
                        alt="SkilledProfessionals"
                        className="why_img"
                      />
                    </div>
                    <div className="why__content">
                      <div className="heading_set">
                        <h3> AR-VR Lab for Schools</h3>
                      </div>
                      <p className="normal-para">
                        Transform your school's learning experience with our
                        cutting-edge Integrated AR-VR Lab.
                      </p>
                    </div>
                  </div>
                </Link>
              </SwiperSlide>
              <SwiperSlide>
                <Link to="https://drive.google.com/file/d/1dO9SSQWZ24CfoNAQyeT9-oXwj_CuzzHt/view?usp=sharing" target="blank">
                  <div className="why___flex">
                    <div className="why__img">
                      <img
                        src="https://ddappcdn.techxr.co/techxrWeb/home/weldingsimimage.png"
                        alt="SkilledProfessionals"
                        className="why_img"
                      />
                    </div>
                    <div className="why__content">
                      <div className="heading_set">
                        <h3>Lab for ITIs : Welding Simulator</h3>
                      </div>
                      <p className="normal-para">
                        Enhance your ITI training programs with our advanced
                        Welding Simulator
                      </p>
                    </div>
                  </div>
                </Link>
              </SwiperSlide>
              <SwiperSlide>
                <Link to="https://durlabhdarshan.com/" target="blank">
                  <div className="why___flex">
                    <div className="why__img">
                      <img
                        src="https://ddappcdn.techxr.co/techxrWeb/home/durlabhdarshandimage.png"
                        alt="SkilledProfessionals"
                        className="why_img"
                      />
                    </div>
                    <div className="why__content">
                      <div className="heading_set">
                        <h3>Durlabh Darshan</h3>
                      </div>
                      <p className="normal-para">
                        Experience spirituality like never before with
                        immersive, peaceful 360° views of your deity from the
                        sanctum.
                      </p>
                    </div>
                  </div>
                </Link>
              </SwiperSlide>

              <SwiperSlide>
                <Link to="https://booking.durlabhdarshan.com/products/vrtherapy" target="blank">
                  <div className="why___flex">
                    <div className="why__img">
                      <img
                        src={VrTherpay}
                        alt="VR Therapy"
                        className="why_img"
                      />
                    </div>
                    <div className="why__content">
                      <div className="heading_set">
                        <h3>VR Therapy</h3>
                      </div>
                      <p className="normal-para">
                        VR Therapy brings calm and emotional healing through
                        immersive experiences—right from the hospital bed.
                      </p>
                    </div>
                  </div>
                </Link>
              </SwiperSlide>
            </Swiper>
          </div>
        </div>
      </div>
    </div>
  );
};
